import { render, staticRenderFns } from "./DataTypeField.vue?vue&type=template&id=237a307c&scoped=true"
import script from "./DataTypeField.vue?vue&type=script&lang=js"
export * from "./DataTypeField.vue?vue&type=script&lang=js"
import style0 from "./DataTypeField.vue?vue&type=style&index=0&id=237a307c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a307c",
  null
  
)

export default component.exports